<div class="xr-page devices-page">
  <header class="xr-page-header">
    <div>
      <h1 class="xr-page-title">{{ 'devices_page.title' | translate }}</h1>
    </div>
    <div class="xr-page-actions">
      <app-company-filter></app-company-filter>
      @if (canEdit) {
        <button type="button" class="xr-btn xr-btn--primary" (click)="openForm(null)">
          <i-tabler name="plus" class="icon-18 d-flex" aria-hidden="true"></i-tabler>
          {{ 'devices.add' | translate }}
        </button>
      }
      @if (canRequest) {
        <button type="button" class="xr-btn xr-btn--primary" (click)="openForm(null, 'request')">
          <i-tabler name="send" class="icon-18 d-flex" aria-hidden="true"></i-tabler>
          {{ 'devices.request' | translate }}
        </button>
      }
    </div>
  </header>

  <div class="devices-summary" role="group" [attr.aria-label]="'devices_page.filter_label' | translate">
    <button type="button" class="devices-tile devices-tile--total"
            [class.active]="statusFilter === 'all'" [attr.aria-pressed]="statusFilter === 'all'"
            (click)="setStatusFilter('all')">
      <span class="devices-tile__label">{{ 'devices_page.filter_all' | translate }}</span>
      <span class="devices-tile__count">{{ companyDevices.length }}</span>
    </button>
    <button type="button" class="devices-tile devices-tile--pending"
            [class.active]="statusFilter === 'pending'" [attr.aria-pressed]="statusFilter === 'pending'"
            (click)="setStatusFilter('pending')">
      <span class="devices-tile__label">{{ 'devices.status_pending' | translate }}</span>
      <span class="devices-tile__count">{{ pendingCount }}</span>
    </button>
    <button type="button" class="devices-tile devices-tile--enabled"
            [class.active]="statusFilter === 'enabled'" [attr.aria-pressed]="statusFilter === 'enabled'"
            (click)="setStatusFilter('enabled')">
      <span class="devices-tile__label">{{ 'devices_page.filter_enabled' | translate }}</span>
      <span class="devices-tile__count">{{ enabledCount }}</span>
    </button>
  </div>

  <section class="xr-card devices-list" [attr.aria-label]="'devices_page.list_label' | translate">
    <label class="xr-search">
      <i-tabler name="search" class="icon-18 d-flex devices-search-icon" aria-hidden="true"></i-tabler>
      <span class="xr-sr-only">{{ 'devices_page.search_label' | translate }}</span>
      <input type="search" [placeholder]="'devices.search' | translate" [formControl]="searchControl"/>
    </label>

    @if (filteredDevices.length) {
      <div class="devices-table-view">
        <table mat-table [dataSource]="filteredDevices" class="w-100 devices-table">
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>{{ 'devices_page.device' | translate }}</th>
            <td mat-cell *matCellDef="let device">
              <div class="device-identity">
                <span class="device-icon" aria-hidden="true"><i-tabler name="device-mobile" class="icon-20 d-flex"></i-tabler></span>
                <div class="device-identity__text">
                  <div class="device-identity__name">{{ device.name }}</div>
                  <div class="device-labels">
                    <span class="xr-badge xr-badge--plain device-label">{{ (device.device_type ? 'devices.type_' + device.device_type : 'devices.type_unknown') | translate }}</span>
                    <span class="xr-badge xr-badge--plain device-label">{{ (device.usage ? 'devices.usage_' + device.usage : 'devices.usage_unknown') | translate }}</span>
                  </div>
                  @if (device.brand || device.model) {
                    <div class="devices-secondary">{{ device.brand }} {{ device.model }}</div>
                  }
                  @if (device.requested_by_name || device.requested_for_name) {
                    <div class="devices-secondary device-request">
                      @if (device.requested_by_name) {
                        {{ 'devices.requested_by' | translate: { name: device.requested_by_name } }}
                      }
                      @if (device.requested_for_name && device.requested_for_name !== device.requested_by_name) {
                        {{ 'devices.requested_for_line' | translate: { name: device.requested_for_name } }}
                      }
                      @if (device.requested_at) {
                        · {{ device.requested_at | date: 'dd/MM/yyyy HH:mm' }}
                      }
                    </div>
                  }
                  @if (device.description) {
                    <div class="devices-secondary">{{ device.description }}</div>
                  }
                </div>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="serial_number">
            <th mat-header-cell *matHeaderCellDef>{{ 'devices.serial_number' | translate }}</th>
            <td mat-cell *matCellDef="let device"><code class="devices-serial">{{ device.serial_number }}</code></td>
          </ng-container>

          <ng-container matColumnDef="company">
            <th mat-header-cell *matHeaderCellDef>{{ 'devices.company' | translate }}</th>
            <td mat-cell *matCellDef="let device">{{ device.company_name }}</td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>{{ 'devices.status' | translate }}</th>
            <td mat-cell *matCellDef="let device">
              <span class="xr-badge" [class.xr-badge--ok]="device.enabled" [class.xr-badge--wait]="!device.enabled">
                {{ (device.enabled ? 'devices.status_enabled' : 'devices.status_pending') | translate }}
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef class="devices-actions-head">{{ 'devices_page.actions' | translate }}</th>
            <td mat-cell *matCellDef="let device">
              <div class="devices-actions">
                @if (device.enabled) {
                  <button type="button" class="xr-btn xr-btn--secondary xr-btn--small" (click)="setEnabled(device, false)">{{ 'devices.disable' | translate }}</button>
                } @else {
                  <button type="button" class="xr-btn xr-btn--primary xr-btn--small" (click)="setEnabled(device, true)">{{ 'devices.approve' | translate }}</button>
                }
                <button type="button" class="xr-btn xr-btn--secondary xr-btn--small" (click)="openForm(device)">
                  {{ 'devices_page.edit' | translate }}
                </button>
                <button type="button" class="xr-btn xr-btn--danger xr-btn--small devices-icon-btn" (click)="deleteDevice(device)"
                        [matTooltip]="'devices_page.delete' | translate" [attr.aria-label]="'devices_page.delete' | translate">
                  <i-tabler name="trash" class="icon-18 d-flex" aria-hidden="true"></i-tabler>
                </button>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="columns"></tr>
          <tr mat-row *matRowDef="let row; columns: columns" [class.devices-row--pending]="!row.enabled"></tr>
        </table>
      </div>

      <div class="devices-card-view">
        @for (device of filteredDevices; track device.id) {
          <article class="device-card" [class.device-card--pending]="!device.enabled">
            <div class="device-card__header">
              <div class="device-identity">
                <span class="device-icon" aria-hidden="true"><i-tabler name="device-mobile" class="icon-20 d-flex"></i-tabler></span>
                <div class="device-identity__text">
                  <h2 class="device-identity__name">{{ device.name }}</h2>
                  <div class="device-labels">
                    <span class="xr-badge xr-badge--plain device-label">{{ (device.device_type ? 'devices.type_' + device.device_type : 'devices.type_unknown') | translate }}</span>
                    <span class="xr-badge xr-badge--plain device-label">{{ (device.usage ? 'devices.usage_' + device.usage : 'devices.usage_unknown') | translate }}</span>
                  </div>
                  @if (device.brand || device.model) {
                    <p class="devices-secondary">{{ device.brand }} {{ device.model }}</p>
                  }
                </div>
              </div>
              <span class="xr-badge" [class.xr-badge--ok]="device.enabled" [class.xr-badge--wait]="!device.enabled">
                {{ (device.enabled ? 'devices.status_enabled' : 'devices.status_pending') | translate }}
              </span>
            </div>

            <dl class="device-card__details">
              <div>
                <dt>{{ 'devices.serial_number' | translate }}</dt>
                <dd><code class="devices-serial">{{ device.serial_number }}</code></dd>
              </div>
              @if (user?.roles?.id === Roles.SUPER_ADMIN) {
                <div>
                  <dt>{{ 'devices.company' | translate }}</dt>
                  <dd>{{ device.company_name || ('dashboard.not_available' | translate) }}</dd>
                </div>
              }
              @if (device.requested_by_name || device.requested_for_name) {
                <div class="device-card__notes">
                  <dt>{{ 'devices.request_label' | translate }}</dt>
                  <dd>
                    @if (device.requested_by_name) {
                      {{ 'devices.requested_by' | translate: { name: device.requested_by_name } }}
                    }
                    @if (device.requested_for_name && device.requested_for_name !== device.requested_by_name) {
                      {{ 'devices.requested_for_line' | translate: { name: device.requested_for_name } }}
                    }
                    @if (device.requested_at) {
                      · {{ device.requested_at | date: 'dd/MM/yyyy HH:mm' }}
                    }
                  </dd>
                </div>
              }
              @if (device.description) {
                <div class="device-card__notes">
                  <dt>{{ 'devices.description' | translate }}</dt>
                  <dd>{{ device.description }}</dd>
                </div>
              }
            </dl>

            @if (canEdit) {
              <div class="device-card__actions">
                @if (device.enabled) {
                  <button type="button" class="xr-btn xr-btn--secondary" (click)="setEnabled(device, false)">{{ 'devices.disable' | translate }}</button>
                } @else {
                  <button type="button" class="xr-btn xr-btn--primary" (click)="setEnabled(device, true)">{{ 'devices.approve' | translate }}</button>
                }
                <button type="button" class="xr-btn xr-btn--secondary" (click)="openForm(device)">
                  {{ 'devices_page.edit' | translate }}
                </button>
                <button type="button" class="xr-btn xr-btn--danger xr-btn--icon" (click)="deleteDevice(device)"
                        [matTooltip]="'devices_page.delete' | translate" [attr.aria-label]="'devices_page.delete' | translate">
                  <i-tabler name="trash" class="icon-18 d-flex" aria-hidden="true"></i-tabler>
                </button>
              </div>
            }
          </article>
        }
      </div>
    } @else if (loaded) {
      <div class="xr-empty">
        {{ (devices.length ? 'devices_page.empty_filter' : 'devices.no_devices') | translate }}
      </div>
    }
  </section>
</div>
